import axios from 'axios'

const withToken = (token) => ({ headers: { Authorization: 'Bearer ' + token } })

// The phone app's endpoints: they take a Firebase token (see utils/firebaseAuth.js)
const FavoriteApi = {
    add(id, token) {
        return axios.post('/api/favorite/' + id, {}, withToken(token))
    },
    delete(id, token) {
        return axios.delete('/api/favorite/' + id, withToken(token))
    },
    all(page, token) {
        return axios.get('/api/favorite', { params: { page }, ...withToken(token) })
    },
}

export default FavoriteApi
